export default class Currency {
    constructor(currency = 'CLP', locale = 'es-CL') {
        this.currency = currency;
        this.locale = locale;
    };

    format(value) {
        return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(value);
    };
}